var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('maintaincost-check',{attrs:{"sna-id":_vm.snaId},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('check-module',{attrs:{"title":"审批"}},[_c('check-handle-module',{attrs:{"pass-dialog-txt":"审批通过后可进行费用划拨。"}})],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }